<template>
    <pop
        :animation="animationType || 'fadeInRight'"
        customClass="detail-pop-wrap"
        :enableAnimation="enableAnimation"
        :showMask="false"
        :allowClose="false"
    >
        <div
            ref="iframeWrap"
            v-loading="loading"
            loading-mask="true"
            class="detail-pop-container"
        ></div>
    </pop>
</template>
<script>
export default {
    data: function () {
        return {
            loading: false,
            enableAnimation: true,
            animationType: this.animation
        };
    },
    props: ['animation'],
    watch: {
        animation(val) {
            this.animationType = val;
        }
    },
    methods: {
        refreshIframUserState() {
            this.$refs.iframeWrap.children[0].contentWindow.siteAppVm.$store.dispatch(
                'getUser',
                { checkOtherIframe: false }
            );
        },
        // md-detaiul-info的banner里面会调用
        hide: function () {
            window.history.back();
            this.display(false);
        },
        setLink: function (link) {
            if (link) {
                var popstateFunc = (event) => {
                    event.preventDefault();
                    window.removeEventListener('popstate', popstateFunc);
                    // 移动端通过手势后退页面, 不需要放动画
                    this.setEnableAnimation(false);
                    this.display(false);
                };
                window.addEventListener('popstate', popstateFunc);

                if (this.link === link) {
                    window.history.pushState({}, null, link);
                } else {
                    this.$nextTick(() => {
                        this.$refs.iframeWrap.innerHTML = `<iframe src="${link}" class="detail-pop" frameborder="0" ></iframe>`;
                        this.$refs.iframeWrap.focus();
                    });
                    this.updateLink(link);
                    window.__curDetailPop = this;
                }
            }
        },
        // iframe的link改变时会调用这个方法改变弹窗记录的link
        updateLink: function (link) {
            this.setLoading(true);
            window.history.pushState({}, null, link);
            this.link = link;
        },
        // 修改loading状态
        setLoading: function (loading) {
            this.loading = loading;
        },
        // 修改enableAnimation
        setEnableAnimation: function (enableAnimation) {
            this.enableAnimation = enableAnimation;
        },
        // 修改弹起方向
        setAnimation: function (animation) {
            this.animationType = animation;
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.detail-pop-wrap {
    display: block;
    width: 100%;
    height: 100%;
    background: #fff;
}
.detail-pop {
    display: block;
    width: 100vw;
    height: 100vh;
    background: #fff;
}
.detail-pop-container {
    -webkit-overflow-scrolling: touch;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    iframe {
        max-height: 100%;
    }
}
</style>
